export const Marquee = ({ items }) => (
  <div className="overflow-hidden border-y border-white/10 py-6" aria-hidden="true">
    <div className="marquee-track flex w-max items-center whitespace-nowrap">
      {[...items, ...items, ...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display text-3xl md:text-4xl font-light text-white/50 px-8">
            {item}
          </span>
          <span className="text-ember text-xl">✦</span>
        </span>
      ))}
    </div>
  </div>
);
